import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanLoad,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Route,
  Data
} from '@angular/router';
import { UserService } from '../services/user.service';
import * as Security from '../tokens/roles.tokens';
import { NavigationService } from '../services';

@Injectable()
export class AuthorizeGuard implements CanActivate, CanLoad {
  constructor(
    private userService: UserService,
    private router: Router,
    private navigationService: NavigationService
  ) {}

  /**
   * Determines whether or not the route can activated based on whether the route requires a role or just an authenticated user.
   */
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkLoggedIn(next.data, state.url);
  }

  /**
   * Determines whether or not a route can load based on whether the route requires a role or just an authenticated user.
   */
  canLoad(route: Route): boolean {
    return this.checkLoggedIn(route.data, route.path);
  }

  /**
   * Ensures that the user is logged in; if not logged in, a redirect to the login page is done.  If already logged in, checks to see
   * if the route is protected by roles, and if so ensures the user has those roles; if not, just returns true.  If they don't, goes
   * to the unauthorized page, if they do, returns true.
   *
   * @param data The route's data
   * @param url The user's desired URL
   */
  private checkLoggedIn(data: Data, url: string) {
    // TODO what about LDS login? we can't just have a "must be logged in" if we try to use this same guard for LDS and Admin access
    // if (
    //   this.userService.isLoggedIn() &&
    //   !this.navigationService.loggedInAsLeader()
    // ) {
    //   // if they're logged in, they'll either get access (if we aren't requiring roles) or be sent to an access denied route
    //   if (data['roles']) {
    //     if (
    //       this.userService.userHasRole([Security.ApplicationRoles.byuiAdmin]) ||
    //       this.userService.userHasRole([Security.ApplicationRoles.byuiLeader])
    //     ) {
    //       return true;
    //     }
    //     this.router.navigate(['/unauthorized']);
    //     return false;
    //   }

    //   return true; // no roles required, just authentication checked
    // }
    if (
      this.userService.isLoggedIn() && (
        this.userService.userHasRole([Security.ApplicationRoles.byuiAdmin]) || this.userService.userHasRole([Security.ApplicationRoles.byuiLeader])
      )
    ) {
      // if they're logged in, they'll either get access (if we aren't requiring roles) or be sent to an access denied route
      if (data['roles']) {
        if (this.userService.userHasRole(data['roles'])) {
          return true;
        }
        this.router.navigate(['/unauthorized']);
        return false;
      }
      return true; // no roles required, just authentication checked
    }
    this.router.navigate(['/unauthorized']);
    return false;
    // not logged in yet
    // this.router.navigate(['/unit-login'], { queryParams: { returnUrl: url } });
    // return false;
  }
}
